import Layout from "../components/publicLayout"
import Banner from "../components/banner";
import FileUploadDownload from '../components/file';


const Components = () => {
    return (
        <div>
            <Layout>
                <Banner
                    title="Make a Referral"
                    content=" "
                />
                <FileUploadDownload />
            </Layout>
        </div>
    );
}

export default Components;